// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-79292e3a] .ant-form-item {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
